import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import DesignerAnalysisItem from './DesignerAnalysisItem';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import ListView from '../shared/lists/ListView';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import ExportButton from '../shared/buttons/ExportButton';

const DesignerAnalysis = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/designeranalysis`;

    useEffect(() => setUrl(postUrl), []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Designer"
                    sort={pageInfo}
                    sortName="Designer"
                />
                <SortableTh
                    content="Total Appointments"
                    sort={pageInfo}
                    sortName="AppointmentsScheduled"
                />
                <SortableTh
                    content="Installed Jobs"
                    sort={pageInfo}
                    sortName="InstalledJobs"
                />
                <SortableTh
                    content="Closing Rate"
                    sort={pageInfo}
                    sortName="ClosingRate"
                />
                <SortableTh
                    content="Installed Sales"
                    sort={pageInfo}
                    sortName="InstalledSales"
                />
                <SortableTh
                    content="% of Total Sales"
                    sort={pageInfo}
                    sortName="PercentOfTotalSales"
                />
                <SortableTh
                    content="Average Sale"
                    sort={pageInfo}
                    sortName="AverageSale"
                />
                <SortableTh
                    content="Revenue Per Lead"
                    sort={pageInfo}
                    sortName="RevenuePerLead"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/designeranalysis"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <DesignerAnalysisItem
            item={item}
            totalRow={item.designer === "TOTAL"}
            key={item.id}
        />
    );

    return (
        <Row>
            <Col>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            From
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            type="date"
                            defaultValue={filter.dateFrom}
                            name="dateFrom"
                            onChange={setFilter}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            To
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            type="date"
                            defaultValue={filter.dateTo}
                            name="dateTo"
                            onChange={setFilter}
                        />
                    </Form.Group>
                </Form.Row>
                <Row className='pb-5 mt-3'>
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default DesignerAnalysis;